import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initial-state";

const { actions, reducer } = createSlice({
  name: "preference",
  initialState,
  reducers: {
    setCounterIncrement(state) {
      state.counter += 1;
    },
    setCounterDecrement(state) {
      state.counter -= 1;
    },
    setPreference(state, actions) {
      state.preferences = actions.payload;
    },
    setIsLoading(state, actions) {
      state.isLoading = actions.payload;
    },
  },
});

export { actions };
export default reducer;
